"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckoutPayment = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _components = require("./components");
var _constants = require("./constants");
var _contexts = require("./contexts");
var _logger2 = require("./logger");
var _jsxRuntime = require("react/jsx-runtime");
const CheckoutPayment = ({
  activeProviderId,
  configuration,
  continueButtonTooltip,
  isPaymentModelLoading,
  paymentModel,
  setActiveProviderId
}) => {
  const extendedConfiguration = {
    ...configuration,
    activeProviderId,
    continueButtonTooltip,
    isPaymentModelLoading,
    paymentModel,
    setActiveProviderId
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: `${_constants.APP_NAME}-boundary`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Loading, {}),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
          team: _testidGenerator.Team.Checkout,
          project: _constants.APP_NAME,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.CheckoutPaymentProvider, {
            value: extendedConfiguration,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _constants.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PaymentStep, {})
            })
          })
        })
      })
    })
  });
};
exports.CheckoutPayment = CheckoutPayment;